import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Textarea } from '@factorialco/f0-react/dist/experimental'
import { Cross } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface ReasonInputProps {
  onAction: (reason?: string) => Promise<boolean | void>
  isExpanded: boolean
  onCancel: () => void
  textareaLabel?: string
  textareaPlaceholder?: string
  confirmButtonLabel: string
}

const ReasonInput: React.FC<ReasonInputProps> = ({
  onAction,
  isExpanded,
  onCancel,
  textareaLabel,
  textareaPlaceholder,
  confirmButtonLabel,
}) => {
  const [reason, setReason] = React.useState('')
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (!isExpanded) {
      setReason('')
    }
  }, [isExpanded])

  const handleSubmit = async () => {
    setLoading(true)
    const handled = await onAction(reason || undefined)

    if (handled) {
      setReason('')
      onCancel()
    }

    setLoading(false)
  }

  if (!isExpanded) {
    return null
  }

  return (
    <Box flexDirection="column" gap="s12" flexGrow>
      <Textarea
        label={textareaLabel || ''}
        hideLabel
        placeholder={textareaPlaceholder}
        value={reason}
        onChange={setReason}
      />
      <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
        <F0Button
          label={i18n.t('common.cancel')}
          variant="outline"
          onClick={onCancel}
          disabled={loading}
          icon={Cross}
        />
        <F0Button
          label={confirmButtonLabel}
          variant="default"
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
        />
      </Box>
    </Box>
  )
}

export default ReasonInput
